import axios from 'axios'
import queryString from 'query-string'

import config from 'config'

export default {
  setup() {
    const STRINGIFY_CONFIG = { arrayFormat: 'none' }

    axios.defaults.baseURL = config.api.url
    axios.defaults.paramsSerializer = (params) =>
      queryString.stringify(params, STRINGIFY_CONFIG)
  },
}
